module.exports = __webpack_public_path__ + "static/trans-white-5c00eb1da13f9c35d4d141f4e32635e7.png";